import removeTrailingSlash from 'ha/utils/urls/removeTrailingSlash';

export default function onEnterDefault(nextState, replace, callback) {
  if (nextState.location.pathname.endsWith('/')) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(nextState.location.pathname),
    });
  }

  callback();
}
